"use client";

import Link from "next/link";
import { Button } from "@/components/ui/button";
import { Home, Search } from "lucide-react";

export default function NotFound() {
    return (
        <main className="flex min-h-screen flex-col items-center justify-center bg-background px-6 text-center">
            <div className="max-w-md">
                <h1 className="text-[8rem] font-extrabold text-muted-foreground leading-none">404</h1>
                <h2 className="text-2xl font-semibold mt-2">صفحه پیدا نشد</h2>
                <p className="text-muted-foreground mt-3 mb-6">
                    به نظر می‌رسد آدرسی که وارد کرده‌اید اشتباه است یا این صفحه دیگر وجود ندارد.
                </p>

                <div className="flex items-center justify-center gap-3">
                    <Button asChild size="lg">
                        <Link href="/" className="flex items-center gap-2">
                            <Home className="w-5 h-5" />
                            صفحه اصلی
                        </Link>
                    </Button>

                    <Button asChild size="lg" variant="outline">
                        <Link href="/search" className="flex items-center gap-2">
                            <Search className="w-5 h-5" />
                            جست‌وجو
                        </Link>
                    </Button>
                </div>
            </div>

            <div className="absolute bottom-10 text-sm text-muted-foreground opacity-60">
                © {new Date().getFullYear()} — ساخته شده با ❤️ توسط تیم شما
            </div>
        </main>
    );
}
